import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <div className="hero-section">
        <h1>UsaAí - Ferramentas Web Úteis</h1>
        <p>Uma central de ferramentas práticas para uso diário, tudo acessível diretamente pelo seu navegador.</p>
        <Link to="/word-counter" className="cta-button">
          Explorar Ferramentas
        </Link>
      </div>

      <div className="features-section">
        <h2>Nossas Ferramentas</h2>
        
        <div className="tools-grid">
          <div className="tool-card">
            <div className="tool-icon">📝</div>
            <h3>Contador de Palavras</h3>
            <p>Conte palavras e caracteres de qualquer texto facilmente.</p>
          </div>
          
          <div className="tool-card">
            <div className="tool-icon">&#123; &#125;</div>
            <h3>Formatador JSON</h3>
            <p>Formate dados JSON para leitura fácil e clara.</p>
          </div>
          
          <div className="tool-card">
            <div className="tool-icon">🖼️</div>
            <h3>Redimensionador de Imagem</h3>
            <p>Redimensione imagens rapidamente sem perder qualidade.</p>
          </div>
          
          <div className="tool-card">
            <div className="tool-icon">📄</div>
            <h3>Conversor para PDF</h3>
            <p>Converta textos e documentos para o formato PDF.</p>
          </div>
          
          <div className="tool-card">
            <div className="tool-icon">▶️</div>
            <h3>Baixar do YouTube</h3>
            <p>Baixe vídeos ou áudios do YouTube diretamente.</p>
          </div>
          
          <div className="tool-card">
            <div className="tool-icon">🔄</div>
            <h3>Conversor de Arquivos</h3>
            <p>Converta entre diferentes formatos de arquivo.</p>
          </div>
          <div className="tool-card">
            <div className="tool-icon">Aa</div>
            <h3>Conversor de Caixa</h3>
            <p>Transforme seu texto em maiúsculas, minúsculas ou título.</p>
          </div>
          <div className="tool-card">
            <div className="tool-icon">🔑</div>
            <h3>Gerador de API Key</h3>
            <p>Gere chaves de API seguras em diferentes formatos.</p>
          </div>
        </div>
        
        <div className="coming-soon">
          <h3>E mais ferramentas em breve!</h3>
          <p>Estamos constantemente adicionando novas funcionalidades.</p>
        </div>
      </div>
    </div>
  );
};

export default LandingPage;